<div class="custom-group-cell" [style.padding]="getPadding()">
    <span *ngIf="!params?.node?.group">{{ params?.value }}</span>
    <span *ngIf="params?.node?.group" (click)="toggleGroup()">
        <span style="margin-right: 10px;"
            [ngClass]="{'ag-icon': true, 'ag-icon-tree-open': params?.node?.expanded, 'ag-icon-contracted': !params?.node?.expanded}"></span>
        <span>{{getKey()}}</span>
        <span> {{urgentLabel()}}</span>
    </span>
</div>